import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.8 0H3.2C1.4 0 0 1.368 0 3.128v15.25c0 1.76 1.4 3.129 3.2 3.129h15.6c1.8 0 3.2-1.37 3.2-3.129V3.128C22 1.368 20.6 0 18.8 0M17 6.843h3v2.932h-3zm-2 2.932H7v-7.82h8zm-10 0H2V6.843h3zm-3 1.956h3v2.932H2zm5 0h8v7.82H7zm10 0h3v2.932h-3zm3-8.603v1.76h-3V1.955h1.8c.7 0 1.2.489 1.2 1.173M3.2 1.955H5v2.933H2v-1.76c0-.684.5-1.173 1.2-1.173M2 18.378v-1.76h3v2.933H3.2c-.7 0-1.2-.489-1.2-1.173m16.8 1.173H17v-2.932h3v1.76c0 .683-.5 1.172-1.2 1.172"
    }, null, -1)
  ]))]))
}
export default { render: render }